import { faArrowRight } from '@fortawesome/pro-regular-svg-icons';
import CavendishOnlineLogo from '@propertypal/shared/src/resources/logos/cavendish-logo-no-bg.png';
import CompareNiLogoImg from '@propertypal/shared/src/resources/logos/compareni-logo-no-bg.png';
import React from 'react';
import { useTheme } from 'styled-components';
import FontAwesomeIcon from '../icons/FontAwesomeIcon';
import { LinkText, Text } from '../typography';
import {
  Container,
  Item,
  ItemContainer,
  CavendishLogo,
  CompareNiLogo,
  ItemContent,
  LogoContainer,
} from './PropertyInsurance.style.pn';

interface PropertyInsuranceProps {
  isSale: boolean;
}

const PropertyInsurance: React.FC<PropertyInsuranceProps> = ({ isSale }) => {
  const theme = useTheme();
  return (
    <Container>
      <Item>
        <ItemContainer colour="#f4faec">
          <div>
            <Text fontSize={20} fontWeight="bold" mb={8}>
              Home Insurance
            </Text>
            <ItemContent>
              <FontAwesomeIcon icon={faArrowRight} />
              <a href="https://www.compareni.com/property-news.htm" rel="nofollow noreferrer" target="_blank">
                Compare {isSale ? 'home' : 'content'} insurance quotes with
              </a>
            </ItemContent>
          </div>
          <LogoContainer>
            <a href="https://www.compareni.com/property-news.htm" rel="nofollow noreferrer" target="_blank">
              <CompareNiLogo src={CompareNiLogoImg.src} alt="CompareNI" />
            </a>
          </LogoContainer>
        </ItemContainer>
      </Item>
      <Item>
        <ItemContainer colour="#dcbeca">
          {isSale ? (
            <div data-testid="insurance-sales-content">
              <Text fontSize={20} fontWeight="bold" mb={8}>
                Life Insurance
              </Text>
              <ItemContent>
                <FontAwesomeIcon icon={faArrowRight} />
                <a
                  href="https://www.cavendishonline.co.uk/life-insurance-propertynews"
                  rel="nofollow noreferrer"
                  target="_blank"
                >
                  Get a free life insurance quote with
                </a>
              </ItemContent>
            </div>
          ) : (
            <div data-testid="insurance-non-sales-content">
              <Text fontSize={20} fontWeight="bold" mb={8}>
                Protect Your Income
              </Text>
              <ItemContent>
                <FontAwesomeIcon icon={faArrowRight} />
                <p>
                  Speak to an income protection expert today,{' '}
                  <LinkText
                    href="https://www.cavendishonline.co.uk/income-protection-propertynews"
                    rel="nofollow noreferrer"
                    target="_blank"
                    textDecoration="none"
                    color={theme.textDark}
                    fontWeight="bold"
                  >
                    click here
                  </LinkText>{' '}
                  or call{' '}
                  <a href="tel:01392 715985" rel="nofollow">
                    01392 715985
                  </a>
                </p>
              </ItemContent>
            </div>
          )}
          <LogoContainer>
            {isSale ? (
              <a href="https://www.cavendishonline.co.uk/propertynews" rel="nofollow noreferrer" target="_blank">
                <CavendishLogo src={CavendishOnlineLogo.src} alt="Cavendish Logo" />
              </a>
            ) : (
              <CavendishLogo src={CavendishOnlineLogo.src} alt="Cavendish Logo" />
            )}
          </LogoContainer>
        </ItemContainer>
      </Item>
    </Container>
  );
};

export default PropertyInsurance;
